/// <reference path="../Controller.ts" />
/// <reference path="../../HTML/Form/Item/MultiText.ts" />
/// <reference path="../../HTML/Editor/MultiText.ts" />
namespace HA.Core.Controller.Form {
    import MultiText = HA.Core.HTML.Form.MultiText;
    import MultiTextEditor = HA.Core.HTML.Editor.MultiText;

    export class MultiTextController extends FormItemController {

        /**
         *
         * @returns {any|string}
         */
        public getValue() {
            return this.getTag().getSelected();
        }

        /**
         *
         * @returns {boolean}
         */
        public isInputItem() {
            return true;
        }

        /**
         *
         * @returns {any}
         */
        protected createItem() {
            const data = toMap({tag: this.getTag()});
            const me = this;

            data.set("click", () => {
                const tag = new MultiTextEditor(toMap({
                    dlist: me.getChoices(),
                    title: me.getTitle(),
                    waccept: () => {
                        me.getFormController().closeSelection(me.getAppId());
                        me.replaceItems(tag.getSelections());
                    },
                    wcancel: () => {
                        me.getFormController().closeSelection(me.getAppId());
                    },
                }));
                const app2 = HA.Core.Service.App.createFSApp(tag);
                me.setAppId(app2.getId());
                me.getFormController().showSelection(app2);
            });

            return new MultiText(data);
        }

        /**
         *
         * @param items
         */
        protected replaceItems(items: any[]) {
            this.getTag().replaceItems(items);
        }

        /**
         *
         * @returns {Map}
         */
        protected getChoices() {
            return this.getTag().getChoices();
        }
    }
}
